import { createSelector } from '@reduxjs/toolkit';
const selectEditor = state => state.editor;

export const selectEditorIsActive = createSelector(
  selectEditor,
  ({ cta_flow, thumbnail_flow, custom_access_flow, video_settings_flow }) =>
    cta_flow || thumbnail_flow || custom_access_flow || video_settings_flow
);

export const selectThumbnailFlow = createSelector(
  selectEditor,
  editor => editor.thumbnail_flow
);

export const selectCtaFlow = createSelector(
  selectEditor,
  editor => editor?.cta_flow
);

export const selectVideoSettingsFlow = createSelector(
  selectEditor,
  editor => editor?.video_settings_flow
);
